// ─── ZLayers ──────────────────────────────────────────────────────────────────
//
// Fonte única de verdade para z-indexes do sistema.
//
// Hierarquia:
//
//  Conteúdo de página (fluxo normal)   →   0
//  Grade: header sticky                →   2
//  Grade: resize handle                →   3
//  ─────────────────────────────────────────────────────────
//  [páginas vivem em translateX — stacking context isolado]
//  ─────────────────────────────────────────────────────────
//  Modais dentro de página (EasyModal) → 100, 200, 300...
//  ─────────────────────────────────────────────────────────
//  [acima daqui: elementos que precisam escapar do translateX]
//  ─────────────────────────────────────────────────────────
//  TaskBar (AppBar)                    → 1200  (padrão MUI appBar)
//  Dropdown da TaskBar (FindTaskBar)   → 1300  (acima da TaskBar)
//  Tooltips globais / Snackbar         → 1400  (acima de tudo)

export const ZLayers = {
  // ── Dentro de página (stacking context local) ──────────────────────────
  page: {
    content:      0,
    stickyHeader: 2,
    resizeHandle: 3,
  },

  // ── Modais dentro de página ────────────────────────────────────────────
  // Gerenciados dinamicamente pelo ZIndexContext (BASE_Z=100, STEP=100)
  modal: {
    base: 100,
    step: 100,
  },

  // ── Elementos globais (escapam do translateX, vivem no document) ───────
  global: {
    taskBar:          1200, // coincide com theme.zIndex.appBar do MUI
    taskBarDropdown:  1300, // dropdown do FindTaskBar, drawers, etc.
    tooltip:          1400, // tooltips e snackbars globais
  },
} as const;